import { unsafeCSS as b, LitElement as m, html as d, nothing as h } from "lit";
import { property as l } from "lit/decorators.js";
import { validPropertyValues as v, defineCustomElement as f } from "@justeattakeaway/pie-webc-core";
const z = `*,*:after,*:before{box-sizing:inherit}@keyframes rotate360{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.c-spinner{--spinner-size: 24px;--spinner-left-color: hsl(var(--spinner-base-color-h), var(--spinner-base-color-s), var(--spinner-base-color-l), 1);--spinner-right-color: hsl(var(--spinner-base-color-h), var(--spinner-base-color-s), var(--spinner-base-color-l), .35);block-size:var(--spinner-size);inline-size:var(--spinner-size);border-radius:var(--dt-radius-rounded-e);border-width:calc(var(--spinner-size) / 8);border-style:solid;border-color:var(--spinner-left-color) var(--spinner-right-color) var(--spinner-right-color) var(--spinner-left-color);will-change:transform;animation:rotate360 1.15s linear infinite;--spinner-base-color-h: var(--dt-color-content-brand-h);--spinner-base-color-s: var(--dt-color-content-brand-s);--spinner-base-color-l: var(--dt-color-content-brand-l)}.c-spinner[variant=secondary]{--spinner-base-color-h: var(--dt-color-content-interactive-secondary-h);--spinner-base-color-s: var(--dt-color-content-interactive-secondary-s);--spinner-base-color-l: var(--dt-color-content-interactive-secondary-l)}.c-spinner[variant=inverse]{--spinner-base-color-h: var(--dt-color-content-inverse-h);--spinner-base-color-s: var(--dt-color-content-inverse-s);--spinner-base-color-l: var(--dt-color-content-inverse-l)}.c-spinner[size=xsmall]{--spinner-size: 16px}.c-spinner[size=small]{--spinner-size: 20px}.c-spinner[size=large]{--spinner-size: 32px}.c-spinner[size=xlarge]{--spinner-size: 48px}.c-spinner-label{position:absolute;display:block;height:1px;width:1px;overflow:hidden;padding:1px;white-space:nowrap}
`, u = ["xsmall", "small", "medium", "large", "xlarge"], y = ["brand", "secondary", "inverse"];
var x = Object.defineProperty, g = Object.getOwnPropertyDescriptor, p = (i, n, s, e) => {
  for (var r = e > 1 ? void 0 : e ? g(n, s) : n, a = i.length - 1, t; a >= 0; a--)
    (t = i[a]) && (r = (e ? t(n, s, r) : t(r)) || r);
  return e && r && x(n, s, r), r;
};
const c = "pie-spinner";
class o extends m {
  constructor() {
    super(...arguments), this.size = "medium", this.variant = "brand";
  }
  render() {
    const { variant: n, size: s, aria: e } = this;
    return d`
            <div
                data-test-id="pie-spinner"
                class="c-spinner"
                role="status"
                aria-live="polite"
                size="${s || "medium"}"
                variant="${n || "brand"}">
                   ${e != null && e.label ? d`<span class="c-spinner-label">${e.label}</span>` : h}
                </div>`;
  }
}
o.styles = b(z);
p([
  l({ type: Object })
], o.prototype, "aria", 2);
p([
  l(),
  v(c, u, "medium")
], o.prototype, "size", 2);
p([
  l(),
  v(c, y, "brand")
], o.prototype, "variant", 2);
f(c, o);
export {
  o as PieSpinner,
  u as sizes,
  y as variants
};
